if (!window.__quickAddModalBound) {
    window.__quickAddModalBound = true;

    var quickAddInflight = {};
    var reopenCartAfterQuickAdd = false;
    var activePlusLoader = null;
    var plusLoaderShownAt = 0;
    var PLUS_LOADER_MIN_MS = 280;

    function getQuickAddHost() {
      return document.querySelector('[data-quick-add-host]') || document.body;
    }

    var OPEN_LOADER_SELECTOR =
      '.product-card__quick-add.is-loading, .fresh-cart-drawer__upsell-add.is-loading, .product-pdp__addon-quick-buy.is-loading, .addon-quickbuy-card__btn.is-loading';

    function clearPlusLoader(immediate) {
      function wipe() {
        if (activePlusLoader) {
          activePlusLoader.classList.remove('is-loading');
          activePlusLoader.removeAttribute('aria-busy');
          activePlusLoader = null;
        }
        document.querySelectorAll(OPEN_LOADER_SELECTOR).forEach(function (btn) {
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
        });
        plusLoaderShownAt = 0;
      }

      if (immediate || !plusLoaderShownAt) {
        wipe();
        return;
      }

      var elapsed = Date.now() - plusLoaderShownAt;
      var delay = Math.max(0, PLUS_LOADER_MIN_MS - elapsed);
      window.setTimeout(wipe, delay);
    }

    function setPlusLoader(trigger) {
      clearPlusLoader(true);
      if (!trigger) return null;

      var loaderBtn = null;

      if (
        trigger.classList.contains('product-card__quick-add') ||
        trigger.classList.contains('fresh-cart-drawer__upsell-add') ||
        trigger.classList.contains('product-pdp__addon-quick-buy') ||
        trigger.classList.contains('addon-quickbuy-card__btn')
      ) {
        loaderBtn = trigger;
      } else if (trigger.closest('[data-fresh-upsell]')) {
        var upsell = trigger.closest('[data-fresh-upsell]');
        loaderBtn = upsell.querySelector('.fresh-cart-drawer__upsell-add') || trigger;
      } else {
        var card = trigger.closest('[data-product-card]');
        if (card) loaderBtn = card.querySelector('.product-card__quick-add');
      }

      if (!loaderBtn) return null;

      loaderBtn.classList.add('is-loading');
      loaderBtn.setAttribute('aria-busy', 'true');
      activePlusLoader = loaderBtn;
      plusLoaderShownAt = Date.now();
      return loaderBtn;
    }

    function closeQuickAddModal(modal, onDone) {
      if (!modal) {
        if (typeof onDone === 'function') onDone();
        return;
      }
      if (!modal.classList.contains('is-open')) {
        if (typeof onDone === 'function') onDone();
        return;
      }

      clearPlusLoader();
      // Instant close — no fade-out.
      modal.classList.remove('is-open', 'is-closing');
      modal.setAttribute('aria-hidden', 'true');
      modal.removeAttribute('data-reopen-cart');

      if (window.ThemeOverlay) {
        window.ThemeOverlay.hide('quick-add');
      } else if (window.history && window.history.replaceState && window.location.hash) {
        var hash = window.location.hash;
        if (!hash || hash === '#' || hash.indexOf('#quick-add-') === 0) {
          window.history.replaceState(
            null,
            document.title,
            window.location.pathname + window.location.search
          );
        }
      }

      if (typeof onDone === 'function') {
        onDone();
      }

      if (reopenCartAfterQuickAdd) {
        reopenCartAfterQuickAdd = false;
        window.setTimeout(function () {
          if (window.FreshCartDrawer && typeof window.FreshCartDrawer.open === 'function') {
            window.FreshCartDrawer.open();
          }
        }, 120);
      }
    }

    window.closeQuickAddModal = closeQuickAddModal;
    window.__setQuickAddReopenCart = function (value) {
      reopenCartAfterQuickAdd = !!value;
    };

    function mountQuickAddHtml(html, modalId) {
      var host = getQuickAddHost();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var modal = doc.querySelector('.quick-add-modal');

      if (!modal) return null;

      // Category rows can pre-render the same product modal multiple times
      // (duplicate ids). Remove every stale copy so getElementById / open
      // never resolve to a modal trapped under [hidden].
      if (modalId) {
        document.querySelectorAll('[id="' + modalId.replace(/"/g, '\\"') + '"]').forEach(function (stale) {
          stale.remove();
        });
      } else {
        var parsedId = modal.getAttribute('id');
        if (parsedId) {
          document.querySelectorAll('[id="' + parsedId.replace(/"/g, '\\"') + '"]').forEach(function (stale) {
            stale.remove();
          });
        }
      }

      Array.prototype.forEach.call(doc.querySelectorAll('style'), function (styleEl) {
        host.appendChild(document.importNode(styleEl, true));
      });

      var imported = document.importNode(modal, true);
      host.appendChild(imported);

      if (typeof window.initQuickAddModals === 'function') {
        window.initQuickAddModals(imported);
      }

      return imported;
    }

    function showQuickAddModal(modal) {
      if (!modal) {
        clearPlusLoader();
        return;
      }

      var host = getQuickAddHost();
      // Never open a modal that is still parked inside a [hidden] section wrapper.
      if (host && (modal.parentElement !== host || modal.closest('[hidden]'))) {
        host.appendChild(modal);
      }

      if (window.history && window.history.replaceState && window.location.hash) {
        var hash = window.location.hash;
        if (!hash || hash === '#' || hash.indexOf('#quick-add-') === 0) {
          window.history.replaceState(
            null,
            document.title,
            window.location.pathname + window.location.search
          );
        }
      }

      function reveal() {
        // Only one quick-add dialog should be open at a time.
        document.querySelectorAll('.quick-add-modal.is-open').forEach(function (el) {
          if (el === modal) return;
          el.classList.remove('is-open', 'is-closing');
          el.setAttribute('aria-hidden', 'true');
        });

        modal.classList.remove('is-closing');
        // Force closed styles before opening so the fade-up always plays.
        void modal.offsetWidth;
        // Clear a leftover ATC spinner if this modal was reused after add-to-cart.
        var stuckSubmit = modal.querySelector('[data-qa-submit].is-loading');
        if (stuckSubmit) {
          var label = stuckSubmit.getAttribute('data-qa-label') || stuckSubmit.textContent || 'Add To Cart';
          stuckSubmit.classList.remove('is-loading');
          stuckSubmit.removeAttribute('aria-busy');
          stuckSubmit.removeAttribute('data-qa-label');
          stuckSubmit.disabled = false;
          stuckSubmit.textContent = label;
        }
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');

        if (window.ThemeOverlay) {
          window.ThemeOverlay.show('quick-add', function () {
            closeQuickAddModal(modal);
          });
        }

        clearPlusLoader();
      }

      // Double rAF so freshly mounted HTML paints closed, then animates open.
      requestAnimationFrame(function () {
        requestAnimationFrame(reveal);
      });
    }

    function applyQuickAddTitle(modal, trigger) {
      if (!modal || !trigger) return;
      var override = trigger.getAttribute('data-quick-add-title');
      if (!override) return;
      override = override.trim();
      if (!override) return;
      var titleEl = modal.querySelector('.quick-add-modal__title');
      if (titleEl) titleEl.textContent = override;
      modal.setAttribute('data-quick-add-display-title', override);
    }

    function applyQuickAddQtyVisibility(modal, trigger) {
      if (!modal) return;
      var onAvaPdp =
        document.body.classList.contains('product-new-pdp-ava-flatware') ||
        !!(trigger && trigger.closest('.addon-quickbuy-card, [data-show-quantity-selector="true"]'));
      var onHomepageOverhaul =
        document.body.classList.contains('ab-show-overhaul') ||
        document.body.classList.contains('index-ab-overhaul-home') ||
        !!(trigger && trigger.closest('[data-product-card], .product-card'));
      if (onAvaPdp) {
        modal.classList.add('quick-add-modal--with-qty');
        modal.classList.remove('quick-add-modal--hide-qty');
      } else if (onHomepageOverhaul) {
        modal.classList.add('quick-add-modal--hide-qty');
        modal.classList.remove('quick-add-modal--with-qty');
      }
    }

    function openQuickAddModal(modalId, src, trigger) {
      var plus = setPlusLoader(trigger);
      var host = getQuickAddHost();
      var modal = modalId ? document.getElementById(modalId) : null;

      // Pre-rendered modals in [hidden] wrappers blink if opened in place — always
      // lift them to the host (or fetch) instead of opening under [hidden].
      if (modal && modal.closest('[hidden]')) {
        if (host) {
          // Drop sibling duplicates with the same id before moving.
          document.querySelectorAll('[id="' + modalId.replace(/"/g, '\\"') + '"]').forEach(function (el) {
            if (el !== modal) el.remove();
          });
          host.appendChild(modal);
        } else {
          modal = null;
        }
      }

      if (modal) {
        if (host && modal.parentElement !== host) {
          host.appendChild(modal);
        }
        if (typeof window.initQuickAddModals === 'function') {
          window.initQuickAddModals(modal);
        }
        applyQuickAddTitle(modal, trigger);
        applyQuickAddQtyVisibility(modal, trigger);
        showQuickAddModal(modal);
        return;
      }

      if (!src) {
        clearPlusLoader();
        return;
      }

      if (quickAddInflight[src]) return;

      quickAddInflight[src] = fetch(src, {
        credentials: 'same-origin',
        headers: { Accept: 'text/html' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Quick add failed');
          return response.text();
        })
        .then(function (html) {
          var mounted = mountQuickAddHtml(html, modalId);
          applyQuickAddTitle(mounted, trigger);
          applyQuickAddQtyVisibility(mounted, trigger);
          showQuickAddModal(mounted);
        })
        .catch(function () {
          clearPlusLoader();
          if (window.ThemeOverlay) window.ThemeOverlay.hide('quick-add');
        })
        .finally(function () {
          delete quickAddInflight[src];
        });
    }

    document.addEventListener('click', function (event) {
      var openTrigger = event.target.closest('[data-quick-add-open]');
      if (openTrigger) {
        // Image / title links should navigate to the PDP unless the card
        // explicitly opts into whole-card Quick View (BYOB).
        var isProductNavLink =
          openTrigger.classList.contains('product-card__image-link') ||
          openTrigger.classList.contains('product-card__title');
        var forceCardQuickAdd = !!openTrigger.closest('[data-open-quick-add-on-click]');
        if (isProductNavLink && !forceCardQuickAdd) {
          return;
        }

        event.preventDefault();
        // Cart / search drawers sit above the overlay — close them before quick view.
        var fromCart = !!openTrigger.closest('[data-fresh-cart-drawer]');
        reopenCartAfterQuickAdd = fromCart;
        if (
          fromCart &&
          window.FreshCartDrawer &&
          typeof window.FreshCartDrawer.close === 'function'
        ) {
          window.FreshCartDrawer.close();
        }
        if (
          openTrigger.closest('[data-fresh-search-drawer]') &&
          window.FreshSearchDrawer &&
          typeof window.FreshSearchDrawer.close === 'function'
        ) {
          window.FreshSearchDrawer.close();
        }
        var modalId = openTrigger.getAttribute('data-quick-add-open');
        var src = openTrigger.getAttribute('data-quick-add-src') || '';
        // Guard against predictive-search URLs that already contain ?… then get ?view= appended.
        if (src) {
          try {
            var u = new URL(src, window.location.origin);
            var path = u.pathname;
            src = path + '?view=quick-add';
          } catch (e) {
            var q = src.indexOf('?');
            src = (q >= 0 ? src.slice(0, q) : src) + '?view=quick-add';
          }
        }
        openQuickAddModal(modalId, src, openTrigger);
        return;
      }

      var closeTrigger = event.target.closest('[data-quick-add-close]');
      if (closeTrigger) {
        event.preventDefault();
        closeQuickAddModal(closeTrigger.closest('.quick-add-modal'));
      }
    });
  }
